import type { Mission } from '../missions.ts'

export const nps: Mission = {
  id: "nps",
  name: "National Park Service",
  short: "NPS",
  call: "Parks",
  kind: "subagency",
  parent: "doi",
  url: "https://www.nps.gov/",
  established: 1916,
  palette: {
    primary: "#4b5e26",
    secondary: "#5f3617",
    accent: "#a86437",
  },
  colorSource: {
    kind: "site",
    url: "https://www.nps.gov/index.htm",
  },
  motif: "mountain",
  mission: {
    text: "The National Park Service preserves unimpaired the natural and cultural resources and values of the National Park System for the enjoyment, education, and inspiration of this and future generations.",
    url: "https://www.nps.gov/aboutus/our-organization.htm",
  },
  fact: {
    text: "On August 25, 1916, President Woodrow Wilson signed the act creating the National Park Service to protect 35 parks and monuments.",
    url: "https://www.nps.gov/articles/quick-nps-history.htm",
  },
  seal: {
    file: "public/seals/nps.svg",
    source: "https://commons.wikimedia.org/wiki/File:US-NationalParkService-Logo.svg",
  },
  identifier: {
    about: "https://www.nps.gov/aboutus/index.htm",
    accessibility: "https://www.nps.gov/aboutus/accessibility.htm",
    foia: "https://www.nps.gov/aboutus/foia/index.htm",
    noFear: "https://www.doi.gov/pmb/eeo/no-fear-act",
    oig: "https://www.doioig.gov/",
    performance: "https://www.nps.gov/aboutus/budget.htm",
    privacy: "https://www.nps.gov/aboutus/privacy.htm",
  },
  media: {
    photos: [
      {
        file: "/media/nps-old-faithful.jpg",
        small: "/media/nps-old-faithful-sm.jpg",
        alt: "Old Faithful geyser erupting at sunset, its steam column merging with dark, sunlit clouds over the geyser basin.",
        title: "Sunset eruption of Old Faithful, Yellowstone National Park",
        creator: "Neal Herbert, National Park Service",
        source: "https://commons.wikimedia.org/wiki/File:Sunset_eruption_of_Old_Faithful_(33756993516).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/nps-grand-teton.jpg",
        small: "/media/nps-grand-teton-sm.jpg",
        alt: "The jagged peaks of the Teton Range rising in blue haze beyond a dense conifer forest.",
        title: "Grand Teton from Cave Falls Road, Yellowstone National Park",
        creator: "Jacob W. Frank, National Park Service",
        source: "https://commons.wikimedia.org/wiki/File:Grand_Teton_from_Cave_Falls_Road_(53954687910).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
    video: {
      webm: "/media/nps-loop.webm",
      mp4: "/media/nps-loop.mp4",
      poster: "/media/nps-loop-poster.jpg",
      title: "B-roll: water flowing in a mountain stream in summer, Rocky Mountain National Park",
      creator: "National Park Service",
      source: "https://www.nps.gov/media/video/view.htm?id=9E04AF2D-D4EF-4D71-8BC6-6F2AC6E41F2C",
      license: "Public domain (U.S. government work)",
    },
  },
}
